import PartnerInfoBlock from './PartnerInfoBlock'
import PartnerInfoCardBlock from './PartnerInfoCardBlock'

export { PartnerInfoBlock, PartnerInfoCardBlock }
